import {
  Box,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  ListSubheader,
} from "@mui/material";
import { useEffect, useState } from "react";
import { api } from "../../services/api";
import { useParams } from "react-router-dom";

const SelectTarifa = ({ open, onClose, onConfirm }) => {
  const [loading, setLoading] = useState(true);
  const [tarifasTickets, setTarifasTickets] = useState([]);
  const [tarifasVouchers, setTarifasVouchers] = useState([]);
  const [selectedTarifa, setSelectedTarifa] = useState("");
  const param = useParams();

  useEffect(() => {
    const fetchTarifas = async () => {
      setLoading(true);
      try {
        const response = await api.tarifas.getAll(param.id,"",100,0);
        if (response.status === "success" && response.data.tarifas) {
          setTarifasTickets(response.data.tarifas.filter(t => t.idtipo === 1));
          setTarifasVouchers(response.data.tarifas.filter(t => t.idtipo === 2));
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchTarifas();
  }, [param.id]);

  const handleConfirm = () => {
    if (!selectedTarifa) return;
    const allTarifas = [...tarifasTickets, ...tarifasVouchers];
    const tarifa = allTarifas.find(t => t.id === selectedTarifa);
    if (tarifa) onConfirm(tarifa);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>Seleccionar tarifa destino</DialogTitle>
      <DialogContent>
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
            <CircularProgress />
          </Box>
        ) : (
          <FormControl fullWidth sx={{ mt: 2 }}>
            <InputLabel>Tarifa</InputLabel>
            <Select
              value={selectedTarifa}
              label="Tarifa"
              onChange={(e) => setSelectedTarifa(e.target.value)}
            >
              <ListSubheader>Tickets</ListSubheader>
              {tarifasTickets.length > 0 ? (
                tarifasTickets.map((t) => (
                  <MenuItem key={t.id} value={t.id}>
                    {t.concepto}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>No hay tickets</MenuItem>
              )}
              <ListSubheader>Vouchers</ListSubheader>
              {tarifasVouchers.length > 0 ? (
                tarifasVouchers.map((v) => (
                  <MenuItem key={v.id} value={v.id}>
                    {v.concepto}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>No hay vouchers</MenuItem>
              )}
            </Select>
          </FormControl>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button
          variant="contained"
          onClick={handleConfirm}
          disabled={!selectedTarifa || loading}
        >
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SelectTarifa;
